<template>
  <v-layout wrap class="grey lighten-2">
    <v-flex xs6>
      <v-list dense class="transparent question-list">
        <v-subheader>Questions</v-subheader>
        <filter-group-list v-for="group in orderedGroups" :group="group" :key="group.id"></filter-group-list>
      </v-list>
    </v-flex>
    <v-flex xs6>
      <v-list dense class="transparent">
        <v-subheader>Answers</v-subheader>
        <v-subheader
          ><strong>{{ SelectedQuestion.properties | titleCase }}</strong></v-subheader
        >
        <answer-list
          v-for="answer in answers"
          :key="answer.id"
          :answer="answer"
          :questionId="SelectedQuestion.id"
        ></answer-list>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import FilterGroupList from './FilterGroupList';
import AnswerList from './AnswerList';

export default {
  components: {
    AnswerList,
    FilterGroupList
  },
  name: 'question-filters',
  props: ['journey'],
  computed: {
    ...mapGetters(['SelectedQuestion']),
    orderedGroups: function() {
      return _.orderBy(this.journey.question_groups, 'number');
    },
    answers: function() {
      return _.orderBy(this.SelectedQuestion.answers, ['value']);
    }
  },
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  }
};
</script>

<style scoped lang="scss">
.question-list {
  height: calc(100vh - 384px);
  max-height: calc(100vh - 384px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

::v-deep .list__tile {
  height: auto !important;
  user-select: unset;
}

::v-deep .list__tile__content {
  /*overflow: auto;*/
}

::v-deep .input-group {
  /*padding-top: 0;*/

  label {
    font-size: 13px;
  }

  .input-group__details::before {
    height: 0;
  }
}
</style>
